module.exports = __webpack_public_path__ + "img/bear.d4c4314d.png";